<div class="d-flex hospitality px-2 mx-2 align-items-center">

  <!-- Marked on the option, not with [value] on the select: the value is set
       before *ngFor has rendered the options, so the select falls back to the
       first one and shows a property nobody chose. -->
  <select class="form-select optionsFont border-0" (change)="onSelectChange($event)">
    <option *ngFor="let option of marsha_code_list" [value]="option.name"
      [selected]="option.name === selectedValue" style="background: #fe5358;">
      {{ option.name }}
    </option>
  </select>
  <div class="vertical-divider mx-2"></div>
  <!-- Left Input -->
  <input type="text" class="hospitality-name w-100 border-0" [value]="selectedMarshaDetails.hospitality_unit_name"
    disabled />

  <!-- Separator -->


  <!-- Right Dropdown -->

</div>